import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Landing from './pages/Landing';
import Register from './pages/Register';
import Login from './pages/Login';
import LeadershipDashboard from './pages/LeadershipDashboard';
import MemberDashboard from './pages/MemberDashboard';
import GroupSelection from './pages/GroupSelection';
import PaymentSuccess from './pages/PaymentSuccess';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import MemberSignup from './pages/MemberSignup';
import ForgotPassword from './pages/ForgotPassword';
import JoinPage from './pages/JoinPage';
import ResetPassword from './pages/ResetPassword';
import SetupPassword from './pages/SetupPassword';
import Lander from './pages/Lander';
import { Toaster } from 'sonner';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

import { API } from './config';

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${API}/auth/me`)
        .then(res => {
          setUser(res.data);
          setLoading(false);
        })
        .catch(() => {
          localStorage.removeItem('token');
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <InstallPrompt />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/register" element={<Register setUser={setUser} />} />
          <Route path="/member-signup" element={<MemberSignup />} />
          <Route path="/setup-password" element={<SetupPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/lander" element={<Lander />} />
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/join/:inviteCode" element={<JoinPage />} />
          <Route 
            path="/group-selection" 
            element={user ? <GroupSelection user={user} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/dashboard" 
            element={
              user ? (
                user.role === 'leadership' ? 
                  <LeadershipDashboard user={user} /> : 
                  (user.role === 'super_admin' || user.role === 'limited_admin') ?
                    <SuperAdminDashboard user={user} /> :
                    <Navigate to="/group-selection" />
              ) : <Navigate to="/login" />
            } 
          />
          <Route 
            path="/member-dashboard/:groupId" 
            element={user ? <MemberDashboard user={user} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/payment-success" 
            element={user ? <PaymentSuccess user={user} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/subscription-success" 
            element={user ? <SubscriptionSuccess user={user} /> : <Navigate to="/login" />} 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;